
'use strict'

if (process.env.NODE_ENV === 'production') {
  module.exports = require('./rdweb-contracts.cjs.production.min.js')
} else {
  module.exports = require('./rdweb-contracts.cjs.development.js')
}
